pageId = 'reports-archived_questions-index'

$(document).on "pjaxload##{pageId }", (e, $page, page) ->
  $('.link-destroy-question').on 'click', tower.questionDestroy
